"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPermissionToProto = void 0;
function trackPermissionToProto(perms) {
    var _a;
    if (!perms.participantSid) {
        throw new Error('Invalid track permission, missing participantSid');
    }
    return {
        participantSid: perms.participantSid,
        allTracks: (_a = perms.allowAll) !== null && _a !== void 0 ? _a : false,
        trackSids: perms.allowedTrackSids || [],
    };
}
exports.trackPermissionToProto = trackPermissionToProto;
//# sourceMappingURL=ParticipantTrackPermission.js.map